/* esm.sh - float-tooltip@1.7.5 */
export * from "/*float-tooltip@1.7.5/esnext/float-tooltip.mjs";
export { default } from "/*float-tooltip@1.7.5/esnext/float-tooltip.mjs";
